import { ITEM_TYPE } from "store/apis/storeAPI/values"

/**
 * use .toString() to get the path from Object.assign root
 * @example
 * APP_ROUTES.UNDER.BOSS.toString()
 * // => "/boss"
 */
export const APP_ROUTES = {
  HOME: "/",
  LEADERBOARD: "/leaderboard",
  STORE: "/store",
  STORE_TON: "/store/ton",
  OFFERS: "/store/offers",
  AUCTION: `/store/auction`,
  AUCTION_HISTORY: `/store/auction/history`,
  CLANS: Object.assign("/clans", {
    CLAN: (clanId: string) => `/clans/clan/${clanId}`
  }),
  STAKING: "/wallet/staking",
  CRAFT: (itemType?: ITEM_TYPE) =>
    `/inventory/craft?itemType=${itemType ?? ITEM_TYPE.SHOVEL}`,
  UNDER: {
    HERO: "/hero",
    BOSS: Object.assign("/boss", {
      LEADERBOARD: Object.assign("/boss/leaderboard", {
        USER: (userId: string) => `/boss/leaderboard/${userId}`
      })
    }),
    ARENA: Object.assign("/arena", {
      ATTACK: "/arena/attack"
    })
  },
  QUESTS: (path?: "missions" | "daily" | "guides") => {
    if (!path) return "/quests"
    return `/quests/${path}`
  },
  POINTS_LEADERBOARD: "/quests/missions/points-leaderboard"
} as const
